/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamItemsIdCancelPreview200,
  GetApiV1ExamItemsIdCancelPreview401,
  GetApiV1ExamItemsIdCancelPreview404,
  GetApiV1ExamItemsIdCancelPreview500,
  GetApiV1ExamItemsIdCancelPreviewPathParams,
  GetApiV1ExamItemsIdCancelPreviewQueryResponse,
} from "../../types/examEvaluationController/GetApiV1ExamItemsIdCancelPreview.ts";
import { examItemCancelPreviewViewModelSchema } from "../examItemCancelPreviewViewModelSchema.ts";

export const getApiV1ExamItemsIdCancelPreviewPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ExamItemsIdCancelPreviewPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamItemsIdCancelPreview200Schema = z.lazy(
  () => examItemCancelPreviewViewModelSchema,
) as unknown as ToZod<GetApiV1ExamItemsIdCancelPreview200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamItemsIdCancelPreview401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamItemsIdCancelPreview401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ExamItemsIdCancelPreview404Schema =
  z.any() as unknown as ToZod<GetApiV1ExamItemsIdCancelPreview404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamItemsIdCancelPreview500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamItemsIdCancelPreview500>;

export const getApiV1ExamItemsIdCancelPreviewQueryResponseSchema = z.lazy(
  () => getApiV1ExamItemsIdCancelPreview200Schema,
) as unknown as ToZod<GetApiV1ExamItemsIdCancelPreviewQueryResponse>;
